module.exports = __webpack_public_path__ + "img/grid-srp-preview-cjdr.4623379d.png";